slickMidia();

function slickMidia() {
    const select = (element) => document.querySelector(element);
    const selectAll = (element) => document.querySelectorAll(element);

    selectAll('.slick2').forEach(slick => {
        const slick2 = slick.getAttribute('data-slick2');
        const content = select(`.slick2[data-slick2="${slick2}"] > ul`);
        const btnPrev = select(`.slick2[data-slick2="${slick2}"] .btn-prev`);
        const btnNext = select(`.slick2[data-slick2="${slick2}"] .btn-next`);
        const sizeScroll = select(`.slick2[data-slick2="${slick2}"] > ul li`).offsetWidth + 16;

        initSlick(content, btnPrev, btnNext, sizeScroll);

        window.addEventListener('resize', ()=> {
            initSlick(content, btnPrev, btnNext, sizeScroll);
            checkArrowYesOrNot();
        });

        function checkArrowYesOrNot() {
            if(content) {
                if(content.offsetWidth < content.scrollWidth) {
                    btnPrev.style.display = 'flex';
                    btnNext.style.display = 'flex';
                } else {
                    btnPrev.style.display = 'none'
                    btnNext.style.display = 'none'
                }
            }
        }
    })

    function initSlick(content, btnPrev, btnNext, sizeScroll) {
        if(content) {
            if(content.offsetWidth < content.scrollWidth) {
                // if((content.offsetWidth + 2) < content.scrollWidth) {
                    const scrollMax = (content.scrollWidth) - (content?.clientWidth);

                    btnPrev?.addEventListener('click', () => {
                        if(content.scrollLeft === 0) scroll(scrollMax)
                        else  scroll(content.scrollLeft - sizeScroll)
                    })

                    btnNext?.addEventListener('click', ()=> {
                        if((content.scrollLeft + 20) >= scrollMax) scroll(0)
                        else scroll(content.scrollLeft + sizeScroll)
                    })


                    function scroll(leftX) {

                        content.scroll({
                            left: leftX,
                            behavior: 'smooth',
                        });
                    }
            } else {
                btnPrev.style.display = 'none'
                btnNext.style.display = 'none'
            }
        }
    }
}
